'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider } from 'react-hook-form';
export const AssociatedDealerForm = ({ id, className, formMethods, onSubmit, children }) => {
    return (_jsx(FormProvider, { ...formMethods, children: _jsx("form", { id: id, "data-testid": "select-customer-form", className: className, onSubmit: formMethods.handleSubmit((data) => {
                if (onSubmit) {
                    onSubmit(data);
                }
            }), children: children }) }));
};
